import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import api from "_api";
import Swal from "sweetalert2";
import { Switch, Space } from "antd";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

// Validation schema
// const validationSchema = Yup.object({
//   product_code: Yup.string().required("โปรดระบุรหัสสินค้า"),
//   // category_id: Yup.object().nullable().required("โปรดระบุหมวดหมู่"),
//   sell_price: Yup.number()
//     .required("โปรดระบุจํานวน")
//     .min(1, "ไม่สามารถน้อยกว่าหรือเท่ากับ 0"),
// });

const productFields = [
  {
    label: "ชื่อแพ็กเกจ",
    name: "name_package",
    type: "autocomplete",
    disabled: true,
  },
  {
    label: "จำนวนเครดิต",
    name: "credit",
    type: "number",
    disabled: true,
    // setAllTime: true,
  },
  {
    label: "จำนวนวัน",
    name: "total_day",
    type: "number",
    disabled: true,
    // setAllTime: true,
  },
  {
    label: "ราคา",
    name: "price",
    type: "number",
    disabled: true,
    // setAllTime: true,
  },
  {
    label: "ประเภทแพ็คเกจ",
    name: "package_type",
    type: "autocomplete",
    options: [
      { label: "สินค้าอื่นๆ", value: "normal" },
      { label: "สินค้ายอดฮิต", value: "popular" },
    ],
  },
  {
    label: "ระยะเวลาแพ็คเกจ",
    name: "date_time",
    type: "number",
  },
  {
    label: "สถานะ",
    name: "status",
    // type: "boolean",
    disabled: true,
    // setAllTime: true,
  },
];

const ModalCreatePackage = ({
  open,
  onClose,
  selectedPackage,
  fetchProductData,
}) => {
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);
  const [newProjectName, setNewProjectName] = useState([]);
  const [oldProjectName, setOldProjectName] = useState([]);

  const fetchExistPackage = async () => {
    try {
      const { data, isStatus } = await api.super_admin.getAllPackages();
      if (isStatus) {
        setNewProjectName(data);
        const optionData = data.map((item) => ({
          label: item.product_code,
          id: item.product_id,
        }));
        setOldProjectName(optionData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchExistPackage();
  }, []);

  // console.log("checking picture display in modal", initialProductUrls);
  useEffect(() => {
    if (selectedPackage) {
      console.log({ selectedPackage });
      const {
        credit,
        end_date,
        name_package,
        price,
        start_date,
        status,
        total_day,
        marketplace_package_id,
        package_type,
      } = selectedPackage;

      formik.setValues({
        name_package: name_package || "",
        credit: credit || "",
        end_date: dayjs(end_date, "DD-MM-YYYY"),
        start_date: dayjs(start_date, "DD-MM-YYYY"),

        total_day: total_day || "",
        price: price || "",
        status: status,
        marketplace_package_id,
        package_type: package_type || "",
      });

      // Set initial image URLs
    }
  }, [selectedPackage]);

  // Formik setup
  const formik = useFormik({
    initialValues: {
      //Product
      name_package: "",
      credit: "",
      total_day: "",
      price: "",
      status: false,
      start_date: "",
      end_date: "",
      package_type: "",
    },
    // validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      console.log("Submitting form with values");
      console.log("valuues", values);
      try {
        const packageData = {
          name_package: values.name_package,
          credit: values.credit,
          price: values.price,
          total_day: values.total_day,
          end_date: values.end_date,
          start_date: values.start_date,
          status: values.status,
          package_type: values.package_type,
        };

        if (selectedPackage) {
          const updatePackage = {
            marketplace_package_id: selectedPackage.marketplace_package_id,
            name_package: values.name_package,
            credit: values.credit,
            price: values.price,
            total_day: values.total_day,
            end_date: values.end_date,
            start_date: values.start_date,
            status: values.status,
            package_type: values.package_type,
          };
          const updateResponse = await api.super_admin.updatePackage(
            updatePackage
          );
          if (updateResponse.isStatus) {
            resetForm();
            onClose();
            fetchProductData();
          } else {
            console.error("Error creating order.");
          }
        } else {
          const createReponse = await api.super_admin.createPackage(
            packageData
          );
          console.log("createReponse", createReponse);
          if (createReponse.isStatus) {
            resetForm();
            onClose();
            fetchProductData();
          } else {
            console.error("Error creating order.");
          }
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        alert(`Error submitting form: ${error.message}`);
      }
    },
  });
  useEffect(() => {
    console.log("Initial Values:", formik.values);
  }, [formik]);
  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        title: "Cancel",
        text: "If you cancel now, your information fills will be discarded.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0066FF",
        cancelButtonColor: "#0066FF",
        reverseButtons: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Keep Editing",
        customClass: {
          confirmButton: "confirm-rounded-button",
          cancelButton: "outlined-button",
          container: "swal2-container-custom", // Add custom class for container
        },
        didOpen: () => {
          // Set z-index in didOpen to ensure it's applied after dialog is rendered
          document.querySelector(".swal2-container-custom").style.zIndex = 1500; // or a higher value
        },
        iconHtml:
          '<svg width="150" height="150" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.4339 0.666016C36.3209 0.666016 46.7673 11.1123 46.7673 23.9993C46.7673 36.8863 36.3209 47.3327 23.4339 47.3327C10.5469 47.3327 0.100586 36.8863 0.100586 23.9993C0.100586 11.1123 10.5469 0.666016 23.4339 0.666016ZM23.4339 5.33268C18.4832 5.33268 13.7353 7.29934 10.2346 10.8C6.73391 14.3007 4.76725 19.0486 4.76725 23.9993C4.76725 28.9501 6.73391 33.698 10.2346 37.1987C13.7353 40.6994 18.4832 42.666 23.4339 42.666C28.3846 42.666 33.1326 40.6994 36.6332 37.1987C40.1339 33.698 42.1006 28.9501 42.1006 23.9993C42.1006 19.0486 40.1339 14.3007 36.6332 10.8C33.1326 7.29934 28.3846 5.33268 23.4339 5.33268ZM23.4339 30.9993C24.0528 30.9993 24.6462 31.2452 25.0838 31.6828C25.5214 32.1203 25.7673 32.7138 25.7673 33.3327C25.7673 33.9515 25.5214 34.545 25.0838 34.9826C24.6462 35.4202 24.0528 35.666 23.4339 35.666C22.8151 35.666 22.2216 35.4202 21.784 34.9826C21.3464 34.545 21.1006 33.9515 21.1006 33.3327C21.1006 32.7138 21.3464 32.1203 21.784 31.6828C22.2216 31.2452 22.8151 30.9993 23.4339 30.9993ZM23.4339 9.99935C24.0528 9.99935 24.6462 10.2452 25.0838 10.6828C25.5214 11.1204 25.7673 11.7138 25.7673 12.3327V26.3327C25.7673 26.9515 25.5214 27.545 25.0838 27.9826C24.6462 28.4202 24.0528 28.666 23.4339 28.666C22.8151 28.666 22.2216 28.4202 21.784 27.9826C21.3464 27.545 21.1006 26.9515 21.1006 26.3327V12.3327C21.1006 11.7138 21.3464 11.1204 21.784 10.6828C22.2216 10.2452 22.8151 9.99935 23.4339 9.99935Z" fill="#ED4040"/></svg>',
      }).then(async (result) => {
        if (result.isConfirmed) {
          formik.resetForm();

          setInitialProductUrls([]); // Clear initial product image URLs
          // setInitialCustomerUrls([]);
          setDeletedImageIds([]);
          onClose();
        }
      });
    } else {
      formik.resetForm();

      setInitialProductUrls([]); // Clear initial product image URLs

      setDeletedImageIds([]);
      onClose();
    }
  };

  const renderFields = (fields) => {
    return fields.map((field, index) =>
      field.name === "date_time" ? (
        <React.Fragment key={index}>
          <Grid item xs={12} sm={2}>
            <Typography variant="subtitle1">
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={10}>
            <div
              style={{
                display: "flex",
                justifyContent: field.specialText
                  ? "space-between"
                  : "flex-start",
                alignItems: "center",
                width: "100%",
                columnGap: "1rem",
              }}
            >
              <FormControl style={{ width: "50%" }}>
                <InputLabel shrink>เวลาเริ่มต้น</InputLabel>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      value={
                        formik.values.start_date
                          ? dayjs(formik.values.start_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(date) => {
                        console.log(date);

                        formik.setFieldValue("start_date", date ? date : "");
                      }}
                      style={{
                        height: "40px",
                        marginTop: "10px",
                      }}
                    />
                    {/* {field.specialText && (
                  <span style={{ marginLeft: "8px" }}>{field.specialText}</span>
                  )} */}
                  </DemoContainer>
                </LocalizationProvider>
              </FormControl>

              <FormControl style={{ width: "50%" }}>
                <InputLabel shrink>เวลาสิ้นสุด</InputLabel>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    <DatePicker
                      value={
                        formik.values.end_date
                          ? dayjs(formik.values.end_date, "DD-MM-YYYY")
                          : null
                      }
                      onChange={(date) =>
                        formik.setFieldValue("end_date", date ? date : "")
                      }
                      style={{
                        height: "40px",
                        marginTop: "10px",
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                {/* {field.specialText && (
                  <span style={{ marginLeft: "8px" }}>{field.specialText}</span>
                )} */}
              </FormControl>
            </div>
          </Grid>
        </React.Fragment>
      ) : (
        <React.Fragment key={index}>
          <Grid item xs={12} sm={2} style={{ marginBottom: "2rem" }}>
            <Typography variant="subtitle1">
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={10}>
            <div
              style={{
                display: "flex",
                justifyContent: field.specialText
                  ? "space-between"
                  : "flex-start",
                alignItems: "center",
                width: "100%",
              }}
            >
              {field.name === "status" ? (
                <>
                  <Switch
                    name="status"
                    value={formik?.values?.status}
                    onChange={(checked) => {
                      formik.setFieldValue("status", checked ? true : false);
                    }}
                  />
                </>
              ) : field.name === "package_type" ? (
                <Autocomplete
                  id={field.name}
                  name={field.name}
                  options={field.options}
                  clearIcon={null}
                  clearOnEscape={false}
                  onChange={(event, value) => {
                    console.log(
                      "checkValueOption",
                      field.options.find(
                        (option) => option.value === formik.values[field.name]
                      )
                    );
                    formik.setFieldValue(field.name, value?.value || "");
                  }}
                  value={
                    field.options.find(
                      (option) => option.value === formik.values[field.name]
                    ) || null
                  }
                  getOptionLabel={(option) => option.label}
                  fullWidth
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          height: "40px",
                          padding: "0px",
                          width: "100%",
                          backgroundColor: "white",
                        },
                      }}
                    />
                  )}
                />
              ) : (
                <>
                  <TextField
                    id={field.name}
                    name={field.name}
                    type={field.type}
                    value={formik.values[field.name]}
                    onChange={formik.handleChange}
                    {...getFieldProps(field.name)}
                    error={
                      formik.touched[field.name] &&
                      Boolean(formik.errors[field.name])
                    }
                    helperText={
                      formik.touched[field.name] && formik.errors[field.name]
                    }
                    fullWidth={!field.width}
                    sx={{ width: field.width }}
                    InputProps={{
                      sx: { height: "40px" },
                      inputProps: {
                        width: field.width || "auto",
                        style: {
                          "-moz-appearance": "textfield",
                          "-webkit-appearance": "none",
                          appearance: "none",
                        },
                        maxLength:
                          field.name === "idCardNumber"
                            ? 13
                            : field.name === "phoneNumber"
                            ? 10
                            : undefined,
                      },
                    }}
                    // disabled={
                    //   (field.disabled && selectedPackage) || field.setAllTime
                    // }
                  />
                  {field.specialText && (
                    <span style={{ marginLeft: "8px" }}>
                      {field.specialText}
                    </span>
                  )}
                </>
              )}
            </div>
          </Grid>
        </React.Fragment>
      )
    );
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  // console.log("New Project Data:", formik.values);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      maxWidth="md"
      fullWidth
      sx={{
        borderRadius: "8px",
      }}
    >
      <DialogTitle>
        <Typography variant="h4">
          {selectedPackage ? "แก้ไขแพ็กเกจ" : "สร้างแพ็กเกจ"}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} sx={{ padding: 3 }}>
            <Grid item xs={12}>
              <Typography sx={{ mb: 3 }} variant="h4">
                ข้อมูลแพ็กเกจ
              </Typography>
              <Grid container spacing={2} sx={{ mb: 3 }}>
                {renderFields(productFields)}
              </Grid>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={handleCancel}
        >
          กลับ
        </GradientButtonOutline>
        {/* <GradientButtonOutline
          variant="outlined"
          sx={{ mr: 1 }}
          onClick={formik.handleSubmit}
          type="submit"
        >
          บันทึก(ดูตัวอย่าง)
        </GradientButtonOutline> */}
        <GradientButton
          variant="contained"
          onClick={formik.handleSubmit}
          type="submit"
        >
          บันทึก
        </GradientButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalCreatePackage;
